import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import CompleteExchangeModal from '../../../../views/order/common/modal/CompleteExchangeModal';
import { orderActions } from '../../../../store/modules/order';
import { ORDER_DELIVERY_TYPE } from '../../../../constants/service/app/orderConstants';
import { setTrim, setClearDash } from '../../../../lib/common';
import withModal from '../../../../lib/hoc/withModal';

class CompleteExchangeModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  택배 방법
       */
      exchangeDeliveryType: ORDER_DELIVERY_TYPE.PARCEL_DELIVERY,
      /**
       *  택배사
       */
      exchangeDeliveryAgentId: null,
      /**
       *  송장번호
       */
      exchangeInvoiceNumber: null,
      /**
       *  구매자 연락처
       */
      exchangeBuyerPhone: this.props.data.buyerPhone,
      /**
       *  수취인 연락처
       */
      exchangeRecipientPhone: this.props.data.recipientPhone,
      /**
       *  배송지
       */
      address: this.props.data.address,
      /**
       *  배송 메시지
       */
      message: this.props.shippingMessage,
    };
  }

  /**
   * 모달 닫기
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({
      name: 'completeExchangeModal',
    });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  /**
   * 교환 완료 하기
   */
  onSubmit = () => {
    const { form, data, completeOrderExchange } = this.props;
    const {
      exchangeDeliveryType,
      exchangeDeliveryAgentId,
      exchangeInvoiceNumber,
      exchangeBuyerPhone,
      exchangeRecipientPhone,
      address,
      message,
    } = this.state;
    const { orderItemId } = data;

    form.validateFields((err) => {
      if (err) return;

      completeOrderExchange({
        orderItemId,
        deliveryType: exchangeDeliveryType,
        deliveryAgentId: exchangeDeliveryAgentId,
        invoiceNumber: setTrim(exchangeInvoiceNumber),
        buyerPhone: setClearDash(exchangeBuyerPhone),
        recipientPhone: setClearDash(exchangeRecipientPhone),
        address,
        message,
      });

      this.closeModal();
    });
  };

  render() {
    const { form, isOpen, data } = this.props;

    return (
      <CompleteExchangeModal
        {...this.state}
        form={form}
        isOpen={isOpen}
        data={data}
        closeModal={this.closeModal}
        setData={this.setData}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.completeExchangeModal.isOpen,
    data: state.order.completeExchangeModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
  completeOrderExchange: orderActions.completeOrderExchange,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(Form.create({})(CompleteExchangeModalContainer)));
